export default "__VITE_ASSET__BvLKZVhh__"